<script setup lang="ts">
import { marketForex } from "~/helpers/live-market";

const tickData = useCustomFetch("/api/mt5/ticks", {
  method: "POST",
  body: {
    symbols: marketForex.map((item) => item.mt5Symbol),
  },
});

const stockData = computed(() =>
  marketForex
    .map((item) => ({
      ...item,
      value: tickData.data.value?.tick_data?.[item.mt5Symbol || item.symbol],
    }))
    .filter((item) => !item.value?.error),
);
</script>

<template>
  <div class="trending-stocks__wrapper">
    <TrendingItem
      v-for="stock in stockData"
      :key="stock.mt5Symbol"
      :name="stock.mt5Name"
      :symbol="stock.mt5Symbol"
      :image="stock.trendingImage"
      :ask="stock.value?.Ask"
      :bid="stock.value?.Bid"
    />

    <div
      class="blureffect"
      data-aos="fade-down"
      data-aos-easing="linear"
      data-aos-duration="1500"
    ></div>
    <div
      class="blureffect"
      data-aos="fade-down"
      data-aos-easing="linear"
      data-aos-duration="1500"
    ></div>
  </div>
</template>
